import { graphql } from 'react-relay';

export const priceInfoFragment = graphql`
    fragment PriceInfo_component on PriceInfo {
        tableheader {
            col
            label
        }
        title
        file {
            ...FileLink_fileLink
        }
        archive {
            ...SimpleLink_simpleLink
        }
        checked
    }
`;
